import {
    Button,
    Flex,
    Heading,
    Link,
    Box
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";
import VisualizarInfo from '../Doenca/VisualizarInfo';
import { format } from "date-fns"
import { Link as ReactLink, useHistory } from 'react-router-dom';
import { Permission, motivoFunc } from '../../../helpers/Funcionalidades';
import { useAuthProvider } from "../../../Context/AuthProvider";
import SemRegistros from '../../components/SemRegistros';

const VisualizarMotivoSituacao = (props) => {

    document.title = 'MCA - Motivo de Situação - Visualizar'
    let history = useHistory();

    function isValidDate(ano, mes, dia, horas, minutos, segundos) {
        return (
            !isNaN(ano) &&
            !isNaN(mes) &&
            !isNaN(dia) &&
            !isNaN(horas) &&
            !isNaN(minutos) &&
            !isNaN(segundos)
        );
    }

    const _IsMounted = useRef(false);
    const [motivoSituacao, setMotivoSituacao] = useState([])
    const [isUpdating] = useState(props.match.params.editar ? true : false)
    let dateObjectInicio;
    let formatedDateInicio;
    let dateObjectFim;
    let formatedDateFim;

    const { roleKeycloack } = useAuthProvider();

    if (motivoSituacao && motivoSituacao?.dataInicio) {
        const [ano, mes, dia, horas, minutos, segundos] = motivoSituacao?.dataInicio;
        if (isValidDate(ano, mes, dia, horas, minutos, segundos)) {
            dateObjectInicio = new Date(ano, mes - 1, dia, horas, minutos, segundos);
            formatedDateInicio = format(dateObjectInicio, 'dd/MM/yyyy');
        }
    }

    if (motivoSituacao && motivoSituacao?.dataFim) {
        const [ano, mes, dia, horas, minutos, segundos] = motivoSituacao?.dataFim;
        if (isValidDate(ano, mes, dia, horas, minutos, segundos)) {
            dateObjectFim = new Date(ano, mes - 1, dia, horas, minutos, segundos);
            formatedDateFim = format(dateObjectFim, 'dd/MM/yyyy');
        }

    }

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function fetchData() {
        MotivoSituacaoService.getMotivoSituacao(props.match.params.id)
            .then(res => {
                setMotivoSituacao(res.data);
            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/motivo-situacao/lista")
                })
            })
    }

    function checkStatus(acao) {
        let updated;
        MotivoSituacaoService.getMotivoSituacao(props.match.params.id)
            .then(res => {
                updated = res.data
                const acaoUp = updated.dataFim ? "reativar" : "inativar";
                if (acaoUp !== acao) {
                    Swal.fire({
                        title: 'Atenção',
                        text: updated.dataFim ?
                            "Este registro já está inativo. Deseja reativá-lo?" :
                            "Este registro está ativo. Deseja inativá-lo?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#169499',
                        cancelButtonColor: '#169499',
                        confirmButtonText: updated.dataFim ?
                            "Sim, quero reativar!" :
                            "Sim, quero inativar!",
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push("/motivo-situacao/alterar-vigencia/" + updated.id);
                        }
                    })
                } else {
                    history.push("/motivo-situacao/alterar-vigencia/" + updated.id);
                }
            })
    }

    const checkTipo = (tipo) => {
        switch (tipo) {
            case 1:
                return "Acolhido";
            case 2:
                return "Desligado";
            case 3:
                return "Pendente";
            default:
                return "Transferido";
        }
    }

    return roleKeycloack && roleKeycloack.includes(motivoFunc.motivoVisualizar) ? (

        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    Visualizar Motivo de Situação
                </Heading>
                <Link as={ReactLink}
                    to="/motivo-situacao/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>
            <Flex
                flexDir="column"
            >
                <Flex
                    mt="25px"
                    flexDir="column"
                    borderRadius="20px"
                    w="100%"
                    overflow="hidden"
                >
                    <VisualizarInfo
                        title="Descrição"
                        info={motivoSituacao.descricao || ""}
                        bgColor="#F9FAFB"
                    />
                    <VisualizarInfo
                        title="Tipo de Motivo de Situação"
                        info={checkTipo(motivoSituacao?.tipoSituacao?.id)}
                        bgColor="#FFFFFF"
                    />



                    {
                        motivoSituacao.riscoVida === "S" &&
                        (
                            <VisualizarInfo
                                title="Risco de Vida"
                                info="Sim"
                                bgColor="#F9FAFB"
                            />
                        )
                    }

                    {motivoSituacao?.extincaoPoderFamiliar === "S" &&
                        <VisualizarInfo
                            title="Houve Extinção do Poder familiar"
                            info={motivoSituacao?.extincaoPoderFamiliar === "S" && "Sim"}
                            bgColor="#FFFFFF"
                        />
                    }
                    <VisualizarInfo
                        title="Data Início"
                        info={`${formatedDateInicio ? formatedDateInicio : ""}`}
                        bgColor={motivoSituacao.riscoVida === "S" ? "#FFFFFF" : "#F9FAFB"}
                    />
                    {
                        motivoSituacao.dataFim &&
                        (
                            <VisualizarInfo
                                title="Data Fim"
                                info={`${formatedDateFim ? formatedDateFim : ""}`}
                                bgColor={motivoSituacao.riscoVida === "S" ? "#F9FAFB" : "#FFFFFF"}
                            />
                        )
                    }
                    <VisualizarInfo
                        title="Conceito"
                        info={motivoSituacao.conceito || ""}
                        bgColor={
                            motivoSituacao.dataFim && (motivoSituacao.riscoVida === "S")
                                ?
                                "#FFFFFF"
                                :
                                (
                                    motivoSituacao.dataFim || (motivoSituacao.riscoVida === "S")
                                        ? "#F9FAFB"
                                        : "#FFFFFF"
                                )
                        }
                    />
                    {
                        motivoSituacao.justificativa &&
                        (
                            <VisualizarInfo
                                title={
                                    motivoSituacao.dataFim == null && motivoSituacao.justificativa == null
                                        ? "Justificativa"
                                        :
                                        (
                                            motivoSituacao.dataFim == null && motivoSituacao.justificativa != null
                                                ? "Justificativa da Reativação"
                                                : "Justificativa da Inativação"
                                        )
                                }
                                info={motivoSituacao.justificativa || ""}
                                bgColor={
                                    motivoSituacao.dataFim && (motivoSituacao.riscoVida === "S")
                                        ?
                                        "#F9FAFB"
                                        :
                                        (
                                            motivoSituacao.dataFim || (motivoSituacao.riscoVida === "S")
                                                ? "#FFFFFF"
                                                : "#F9FAFB"
                                        )
                                }
                            />
                        )
                    }
                </Flex>

                <Flex mt={2} justifyContent="space-between">
                    <Flex></Flex>
                    <Flex flexDir="row">
                        {motivoSituacao.dataFim ? (
                            <></>
                        ) : (
                            <Permission
                                roleKeycloack={roleKeycloack}
                                func={motivoFunc.motivoEditar}>
                                <Link as={ReactLink} to={"/motivo-situacao/editar/" + motivoSituacao.id}
                                    _hover={{ textDecoration: 'none' }}>
                                    <Button
                                        mr={2}
                                        mt={4}
                                        colorScheme={"teal"}

                                        px={14}
                                        type="button">
                                        {isUpdating ? "Cancelar" : "Editar"}
                                    </Button>
                                </Link>
                            </Permission>
                        )}
                        <Permission
                            roleKeycloack={roleKeycloack}
                            func={motivoSituacao.dataFim ? motivoFunc.motivoReativar : motivoFunc.motivoInativar}>
                            <Button
                                mt={4}
                                mr={2}
                                colorScheme={"teal"}
                                px={14}
                                data-acao={motivoSituacao.dataFim ? "reativar" : "inativar"}
                                onClick={(e) => {
                                    checkStatus(e.target.dataset.acao)
                                }}
                                type="button">
                                {motivoSituacao.dataFim ? "Reativar" : "Inativar"}
                            </Button>
                        </Permission>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default VisualizarMotivoSituacao;